import { Box, IconButton, Modal, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
// import Louise_Testimonial from "../Assets/video/ClientTestimonial/Louise_Testimonial.mp4";
// import Peter_Testimonial from "../Assets/video/ClientTestimonial/Peter_Testimonial.mp4";
// import George_Testimonial from "../Assets/video/ClientTestimonial/George_Testimonial.mp4";
// import FullLogoIcon from "../Assets/Images/FullLogoIcon.png";
import { CloseOutlined, PlayCircleOutline } from "@mui/icons-material";

const cards = [
  { id: 1, name: "Louise Heffernan", position: "Founder & CEO", role: "CEO", image: '/Images/ClientTestimonial/louise.png', logo: '/Images/ClientTestimonial/CompanyLogo/mysterymanagement2.png', video: "/video/ClientTestimonial/Louise_Testimonial.mp4" },
  { id: 2, name: "George Parthimos", position: "Founder & CEO", role: "CTO", image: '/Images/ClientTestimonial/george.png', logo: '/Images/ClientTestimonial/CompanyLogo/wolfpack2.png', video: "/video/ClientTestimonial/George_Testimonial.mp4" },
  { id: 4, name: "David Schneiders", position: "Ops Executive", role: "Director", image: '/Images/ClientTestimonial/devid.png', logo: '/Images/ClientTestimonial/CompanyLogo/redarc.png', video: null },
  { id: 3, name: "Peter Parthimos", position: "Founder & CEO", role: "Manager", image: '/Images/ClientTestimonial/peter.png', logo: '/Images/ClientTestimonial/CompanyLogo/futsaloz.png', video: "/video/ClientTestimonial/Peter_Testimonial.mp4" },
];



export default function Carousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [openVideo, setOpenVideo] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));

  const handlePlay = (video) => {
    setCurrentVideo(video);
    setOpenVideo(true);
  };

  useEffect(() => {
    if (openVideo || isHovered) return;
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % cards.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [openVideo, isHovered]);

  const getPosition = (index) => {
    const total = cards.length;
    return (index - activeIndex + total) % total;
  };

  // Responsive translate distance
  const translateValue = isMobile ? 90 : isTablet ? 75 : 70;

  // Responsive height
  const containerHeight = isMobile ? '50dvh' : isTablet ? 450 : '90dvh';

  return (
    <Box height={containerHeight}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          overflow: "hidden",
          height: "100%",
        }}
      >
        {cards.map((card, index) => {
          const position = getPosition(index);

          return (
            <Box
              className='border-10'
              key={card.id}
              onClick={() => setActiveIndex(index)}
              onMouseEnter={() => position === 0 && setIsHovered(true)}
              onMouseLeave={() => position === 0 && setIsHovered(false)}
              sx={{
                position: "absolute",

                width: {
                  xs: "100%",
                  sm: "55%",
                  md: "34%",
                  // lg: "30%",
                  // xl: "30%",
                },

                height: "100%",

                // borderRadius: 4,
                overflow: "hidden",
                transition: "all 0.8s ease",
                //   cursor: "pointer",

                transform: `
                translateX(${-position * translateValue}%)
                scale(${1 - position * 0.1})
              `,

                zIndex: cards.length - position,
                opacity: position > 3 ? 0 : 1,
              }}
            >
              <Box
                component="img"
                src={card.image}
                sx={{
                  width: "100%",
                  // height:'auto',
                  height: "100%",
                  objectFit: "cover",
                }}
              />

              {position === 0 && (
                <Box
                  className='d-flex align-items-end justify-content-between'
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    height: '50%',
                    background:
                      "linear-gradient(to top, rgb(0, 54, 61), transparent)",
                    color: "#fff",
                    p: { xs: 2, md: 2 },
                  }}
                >
                  {card.video && (<IconButton className="m-0 p-0" 
                  onClick={() => handlePlay(card.video)}
                    ><PlayCircleOutline sx={{ fontSize: '64px', color: '#FFFFFF' }} /></IconButton>
                  )}
                  <Box flex={1} className='d-flex  mt-3 flex-column align-items-end justify-content-end'>
                    <Typography sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" }, 
                      lineHeight: "normal",
                    }} lineHeight={'normal'} className="text-white m-0" gutterBottom>{cards[activeIndex].name}</Typography>
                    <Typography variant="h6" lineHeight={'normal'} className="text-white m-0 pb-3" gutterBottom>{cards[activeIndex].position}</Typography>
                    <Box component={'img'} maxHeight={'50px'} maxWidth={'160px'} src={cards[activeIndex].logo} />
                  </Box>
                </Box>
              )}
            </Box>
          );
        })}
      </Box>

      <Modal  open={openVideo} onClose={() => setOpenVideo(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", md: "60%" },
            bgcolor: "black",
            outline: "none",
          }}
        >
          <IconButton
            onClick={() => {
              setOpenVideo(false);
              setCurrentVideo(null);
            }}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#fff",
              zIndex: 2,
              background: "rgba(0,0,0,0.4)",
              "&:hover": {
                background: "rgba(0,0,0,0.6)",
              },
            }}
          >
            <CloseOutlined />
          </IconButton>
          {currentVideo && (
            <video
              src={currentVideo}
              controls
              autoPlay
              style={{ width: "100%" }}
            />
          )}
        </Box>
      </Modal>
    </Box>
  );
}